import { create } from 'zustand';
import { Hotel } from '../types/hotel';
import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '../lib/firebase/config';

type HotelsState = {
  hotels: Record<string, Hotel>;
  loading: boolean;
  error: string | null;
  fetchHotels: () => Promise<void>;
};

export const useHotelsStore = create<HotelsState>((set) => ({
  hotels: {},
  loading: false,
  error: null,

  fetchHotels: async () => {
    set({ loading: true, error: null });
    try {
      const unsubscribe = onSnapshot(
        collection(firestore, 'Hotels'),
        (snapshot) => {
          const hotels: Record<string, Hotel> = {};
          snapshot.forEach((doc) => {
            hotels[doc.id] = {
              ...doc.data(),
              id: doc.id
            } as Hotel;
          });
          set({ hotels, loading: false });
        },
        (error) => {
          console.error('Error in hotels listener:', error);
          set({ error: error.message, loading: false });
        }
      );

      return unsubscribe;
    } catch (error: any) {
      console.error('Error fetching hotels:', error);
      set({ error: error.message, loading: false });
    }
  }
}));